module.exports = __webpack_public_path__ + "static/media/10.f3b4efd4.jpg";